import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'imprint-cookie-consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return undefined;
    const timer = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  const choose = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-50 rounded-2xl bg-[#0a0b10] text-white p-5 sm:p-6 shadow-2xl border border-white/10 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <div className="flex items-start gap-3 mb-4">
        <Cookie size={20} className="text-[#00BCE4] flex-shrink-0 mt-0.5" />
        <p className="text-sm text-white/85 leading-relaxed" style={{ fontFamily: 'Inter, sans-serif' }}>
          We use cookies to enhance your browsing experience and analyse site
          traffic. See our{' '}
          <Link
            to="/privacy-policy"
            data-testid="cookie-consent-privacy-link"
            className="text-[#00BCE4] hover:underline underline-offset-2"
          >
            Privacy Policy
          </Link>{' '}
          for details.
        </p>
      </div>
      <div className="flex gap-3">
        <button
          type="button"
          onClick={() => choose('accepted')}
          data-testid="cookie-consent-accept"
          className="flex-1 px-4 py-2.5 rounded-full bg-[#00BCE4] text-[#0a0b10] text-xs font-semibold uppercase tracking-wider hover:bg-[#33cae9] transition-colors"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Accept
        </button>
        <button
          type="button"
          onClick={() => choose('declined')}
          data-testid="cookie-consent-decline"
          className="flex-1 px-4 py-2.5 rounded-full border border-white/20 text-white/70 text-xs font-semibold uppercase tracking-wider hover:border-white/40 hover:text-white transition-colors"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
